import { ProcessMessage } from './useProcessMessage'
import useUser from '../useUser'
import { useHistory, useLocation } from 'react-router-dom'
import { Command, IBackgroundLocationState } from '../../config/appConfig'
import { COMMAND_PREFIX } from '../../pages/Commands'
import { TimeTrackingNotification } from './useProcessTimeTrackingNotification'

/**
 * Message in order to revoke a TimeSuggestionDialog.
 */
export type CancelTimeTrackingNotification = ProcessMessage<{
    timeSuggestionId: string
}>

/**
 * Process a cancel time tracking event message. This revokes the TimeSuggestionDialog.
 */
export default function useProcessCancelTimeTrackingNotification() {
    const { currentUser } = useUser()
    const history = useHistory<IBackgroundLocationState>()
    const location = useLocation<TimeTrackingNotification>()

    return (message: CancelTimeTrackingNotification) => {
        if (currentUser?.useTimePopup === false) {
            // Only navigate away from the time tracking popup when the user actually uses the popups.
            return
        }

        //Only cancel the time tracking dialog when the timeSuggestionId match.
        if (
            location.pathname === `${COMMAND_PREFIX}/${Command.TrackTime}` &&
            message.data?.timeSuggestionId === location.state?.data?.timeSuggestionId
        ) {
            history.push(history.location.state?.background?.pathname || '/')
        }
    }
}
